import { Icon, IconName, Text } from '@lawpilots/design-system'
import { Box } from '@mui/material'
import { ReactNode } from 'react'

// The glyph-and-secondary-text rows in the body of a learner card (duration, available until,
// issued...). Shared so the two learner screens' cards keep the same rhythm. `compact` is the
// phone treatment, where the rows drop to small text.

const MetadataListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  padding: '8px 0',
  color: 'var(--colors-text-secondary)',
}

const MetadataLineStyles = { display: 'flex', alignItems: 'center', gap: 1 }

export const MetadataList = ({ children }: { children: ReactNode }): JSX.Element => (
  <Box sx={MetadataListStyles}>{children}</Box>
)

type MetadataLineProps = {
  icon: IconName
  children: ReactNode
  compact?: boolean
}

export const MetadataLine = ({ icon, children, compact = false }: MetadataLineProps): JSX.Element => (
  <Box sx={MetadataLineStyles}>
    <Icon name={icon} size="sm" />
    <Text variant={compact ? 'body-compact' : 'body-reading'} color="secondary" as="span">
      {children}
    </Text>
  </Box>
)
